// Функция для получения цвета игрока в CSS формате
export const getHexOutlineMarkerColor = () => {
  return 0xFFFFFF;
};